module.exports = __webpack_public_path__ + "img/desktop/Background/background@2x.jpg?1.0.17";